export const SIGN_SUCCESS = '@signVerify/sign-success';
export const INPUT_CHANGE = '@signVerify/input-change';
export const TOUCH = '@signVerify/touch';
export const CLEAR_SIGN = '@signVerify/clear-sign';
export const CLEAR_VERIFY = '@signVerify/clear-verify';
export const ERROR = '@signVerify/error';
